import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const reviewApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReviews: builder.query({
      query: ({provider_id}) => {
        return `review?provider_id=${provider_id}`;
      },
      providesTags: ['Review'],
    }),
    createReview: builder.mutation({
      query: body => ({
        url: 'review/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Review'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetReviewsQuery,
  useCreateReviewMutation
} = reviewApi;
